import $ from "jquery";

$(document).ready(function () {
    devis.init();
    devis.devisDocumentId = $('[data-devis-id]').attr('data-devis-id');
    devis.loadMainPosition = null;

    connection.loadPart($('#catalogs-list'), () => {
        if (history.state && history.state.catalogId) {
            if (history.state.mainPosition) {
                devis.loadMainPosition = history.state.mainPosition;
            }

            var activeCatalog = $('#catalog-tree-table [data-tt-id="'+history.state.catalogId+'"]');
            activeCatalog.click();
            if (!activeCatalog.is(':visible')) {
                while (activeCatalog.attr('data-tt-parent-id')) {
                    devis.catalogTreeTable.treetable("expandNode", activeCatalog.attr('data-tt-parent-id'));
                    activeCatalog = $('#catalog-tree-table [data-tt-id="'+activeCatalog.attr('data-tt-parent-id')+'"]');
                }
            }
        }
    });
});

$(document).on('content-ready', function (ev, container) {
    container.find('[data-catalog-clear]').on('click', ev => {
        history.pushState({}, null, null);
        connection.loadPartWith($('#catalog-subpositions'), {
            data: {
            },
            onSuccess: () => {
                // $('#catalog-subpositions').html('');
            },
        });
    });
    container.find('#catalog-tree-table [data-catalog]').on('click', (ev) => {
        var catalogId = $(ev.currentTarget).attr('data-tt-id');

        $('#catalog-tree-table .active').removeClass('active');
        $(ev.currentTarget).addClass('active');

        history.pushState({catalogId: catalogId}, null, null);
        connection.loadPartWith($('#catalog-subpositions'), {
            data: {
                id: catalogId,
            },
            onSuccess: () => {
                $('#catalog-subpositions [data-id]').each((i, el) => {
                    var $el = $(el);
                    var isInDevis = $('#devis-positions [data-original-id="'+$el.attr('data-id')+'"]').length !== 0;
                    if (isInDevis) {
                        $el.addClass('is-in-devis');
                    }
                });
            },
        });
    });

    $.each(container.find('[data-devis-print-addresses]'), (i, target) => {
        var addressEl = $(target);
        addressEl.find('[data-address]').click((clickEv) => {
            var target = $(clickEv.target);
            addressEl.find('.field-type').val(target.attr('data-type'));
            addressEl.find('.field-address').val(target.attr('data-address').replaceAll('||', '|').replaceAll('|', '\n').trim());
        });
    });

    container.find('[data-ckeckbox="ShowAmountField"]').on('checkbox.changed', (ev, data) => {
        var amountEl = $(ev.target).closest('tr').find('[data-devis-field="Amount"]');
        if (data.checked) {
            amountEl.attr('disabled', 'disabled');
        } else {
            amountEl.removeAttr('disabled');
        }
    });

    var fields = container.find('[data-devis-field]');
    fields.click((ev) => {
        var $target = $(ev.currentTarget);
        if ($target.is('.unit-select')) {
            if ($target.find('.dropdown-menu').length === 0) {
                var current = $target.text().trim();
                $target.attr('contenteditable', true).addClass('dropdown').focus();
                $target.append('<div class="dropdown-menu show dropdown-menu-right" style="max-height:300px;overflow:auto;" contenteditable="false">' +
                    '  <div class="dropdown-item linkify" data-value="">Einheit wählen</div>' +
                    devis.unitsList +
                    '</div>');
                $target.find('[data-value="'+current+'"]').addClass('active');
                $target.find('[data-value]').click((ev) => {
                    ev.stopPropagation();
                    var data = {
                        Unit: $(ev.target).attr('data-value'),
                    };
                    $target.text(data.Unit).blur();
                    $target.find('.dropdown-menu').remove();
                    return false;
                });
            }
        } else if ($target.is('.html-editor')) {
            if (!$target.data('editor')) {
                InlineEditor
                    .create($target[0], {
                        forcePasteAsPlainText: true,
                        updateSourceElementOnDestroy: true,
                        toolbar: [
                            'bold', 'italic', 'strikethrough', 'subscript', 'superscript', 'fontcolor',
                            '|', 'hr', 'link', 'bulletedList', 'numberedList',
                            '|', 'undo', 'redo'
                        ]
                    })
                    .then(editor => {
                        $target.data('editor', editor);
                        editor.focus();
                        editor.model.document.on('change:data', (evt) => {
                            if (window.editorSaveTimeout) {
                                clearTimeout(window.editorSaveTimeout);
                                window.editorSaveTimeout = null;
                            }
                            window.editorSaveTimeout = setTimeout(() => {
                                var data = {};
                                data[$target.attr('data-devis-field')] = $target.data('editor').getData();
                                devis.saveDevisPosition($target.closest('[data-id],[data-new]'), data);
                            }, 5000);
                        });
                        editor.ui.focusTracker.on('change:isFocused', (evt, name, isFocused) => {
                            if (!isFocused) {
                                if (window.editorSaveTimeout) {
                                    clearTimeout(window.editorSaveTimeout);
                                    window.editorSaveTimeout = null;
                                }
                                var data = {};
                                data[$target.attr('data-devis-field')] = $target.data('editor').getData();
                                devis.saveDevisPosition($target.closest('[data-id],[data-new]'), data);
                            }
                        } );
                    })
                    .catch(error => {
                        console.error(error);
                    });
            } else {
                $target.data('editor').focus();
            }
        } else {
            if ($target.not('[disabled]')) {
                $target.attr('contenteditable', true).focus();
            }
        }
    });
    fields.keydown((ev) => {
        var $target = $(ev.currentTarget);
        var keyCode = event.keyCode;
        if (keyCode === 9) { // tab
            devis.focusNextOf($target);
            ev.preventDefault();
        }
        if ($target.is('.dropdown')) {
            var selectedEl = $target.find('.active');
            if (keyCode === 13) { // enter
                selectedEl.trigger('click');
                ev.preventDefault();
            }
            if (keyCode === 38) { // arrow-up
                if (!selectedEl) {
                    $target.find('.dropdown-item:last-child').addClass('active');
                }
                if (selectedEl.prev()) {
                    selectedEl.prev().addClass('active');
                    selectedEl.removeClass('active');
                    ev.preventDefault();
                }
            }
            if (keyCode === 40) { // arrow-down
                if (!selectedEl) {
                    $target.find('.dropdown-item:nth-child(1)').addClass('active');
                }
                if (selectedEl.next()) {
                    selectedEl.next().addClass('active');
                    selectedEl.removeClass('active');
                    ev.preventDefault();
                }
            }
        }
    });
    connection.applyValueChange(fields.not('.html-editor'), {
        onChange: function(field, oldValue, value) {
            var data = {};
            data[field.attr('data-devis-field')] = value;
            devis.saveDevisPosition(field.closest('[data-id],[data-new]'), data);

            field.prop('contenteditable', false);
        },
        onLeave: function(field) {
            field.find('.dropdown-menu').remove();
            field.prop('contenteditable', false);
        },
    });

    container.find('.devis-attachments[data-upload-container],.devis-invitation-attachments[data-upload-container]').on('file-added', (ev, file) => {
        var $list = $(ev.currentTarget).find('.list-group');
        var $newFile = $list.find('[data-id="__id__"]');
        var newFileHtml = $newFile[0].outerHTML;
        newFileHtml = newFileHtml.replaceAll('__id__', file.response.file.id)
            .replaceAll('__name__', file.response.file.name);
        var fileEl = $(newFileHtml);
        $newFile.before(fileEl);
        fileEl.addClass('d-flex').removeClass('d-none');
        onContentReady(fileEl);
    });

    container.find('[data-add-to-devis]').on('click', function() {
        devis.addPositionToDevis($(this).attr('data-add-to-devis'));
    });

    container.find('.position-add').on('click', function() {
        devis.addNewPosition($(this).closest('tbody'), false);
    });

    if (container.is('#catalogs-list')) {
        devis.initCatalogTree(container);
    }

    container.find('[data-remove-condition]').click((ev) =>  {
        $(ev.currentTarget).closest('.sort-item').remove();
    });

    container.find('[data-condition-add]').click((ev) =>  {
        var list = $('.conditions-list');
        var type = $(ev.currentTarget).attr('data-condition-add');
        var newItemEl = list.find('[data-template]').clone();
        newItemEl.removeClass('d-none').addClass('sort-item').removeAttr('data-template');
        newItemEl.find('.field-type').val(type);
        var index = Math.random()+'-'+dayjs().millisecond();
        newItemEl.find('input').each((i, el) => {
            $(el).attr('name', $(el).attr('name').replace("__i__", index));
        });
        if (type === 'total') {
            newItemEl.find('.icon').addClass('bi-equals');
            newItemEl.find('.field-name').val('Zwischentotal');
            newItemEl.find('.field-amount').addClass('d-none');
        }
        if (type === 'rabatt') {
            newItemEl.find('.icon').addClass('bi-dash');
            newItemEl.find('.field-name').val('Rabatt');
        }
        if (type === 'plus') {
            newItemEl.find('.icon').addClass('bi-plus');
        }

        list.append(newItemEl);
        newItemEl.find('[data-remove-condition]').click((ev) =>  {
            $(ev.currentTarget).closest('.sort-item').remove();
        });
        debugger;
        list.sortable("refresh");
    });

    // suche: https://searchservice.ausschreiben.de/api/v3/Search/catalogKey/acomarkant/suggest?searchTerm=fenster
    // liste: https://searchservice.ausschreiben.de/api/v3/Search/catalogKey/acomarkant/search?searchTerm=Fensterzarge&pageIndex=0&pageSize=30&maxTeaserLength=100
    // detail: https://catalog.ausschreiben.de/api/v3/CatalogView/catalogItemGuid/3e84b85d-0457-4147-8205-f0afa72d39a7/details
});

var devis = {
    devisDocumentId: null,
    units: {
        "m": "Meter",
        "m2": "Quadratmeter",
        "m3": "Kubikmeter",
        "St": "Stück",
        "pl": "pauschal",
        "LE": "Leistungseinheit",
        "gl": "global",
        "h": "Stunde",
        "d": "Tag",
        "kg": "Kilogramm",
        "t": "Tonne",
        "Wo": "Woche",
        "mt": "Monat",
        "l": "Liter",
        "hl": "Hektoliter",
        "%": "Prozent",
        "%o": "Promille",
        "kJ": "Kilojoule",
        "Kb": "Kübel",
        "S": "Sack",
        "Ro": "Rolle",
        "Pr": "Paar",
        "Kr": "Karrette",
    },
    unitsList: '',
    catalogTreeTable: null,

    init: function() {
        var unitsList = [];
        $.each(devis.units, function(unit, i) {
            unitsList.push('<div class="dropdown-item linkify" data-value="'+unit+'">'+i+' ('+unit+')</div>');
        });
        devis.unitsList = unitsList.join('');
    },

    initCatalogTree: function(treeEl) {
        devis.catalogTreeTable = treeEl.find('table');
        devis.catalogTreeTable.treetable({
            expandable: true,
            clickableNodeNames: true,
            indent: 15,
            expanderTemplate: '<a class="linkify loader-indicator" href="#"><i class="fa bi-plus"></i><i class="fa bi-dash"></i><i class="fa bi-arrow-repeat fa-spin"></a>',
        });
        devis.catalogTreeTable.treetable("expandNode", -1);
        var node = devis.catalogTreeTable.treetable("node", -1);
        devis.catalogTreeTable.treetable("sortBranch", node, devis.treeSortFunction);

        // $('#catalog-positions').empty();
        // $('#catalog-subpositions').empty();

        devis.catalogTreeTable.find("[data-tt-id]").not('.home').draggable({
            helper: "clone",
            opacity: .75,
            refreshPositions: true,
            revert: "invalid",
            revertDuration: 300,
            scroll: true,
        });

        devis.catalogTreeTable.find("[data-tt-id].folder").each(function() {
            $(this).closest("tr").droppable({
                accept: ".file, .folder",
                drop: function(e, ui) {
                    var droppedEl = ui.draggable;
                    var targetParentId = $(this).data("ttId");
                    connection.getJson('/Devis/Default/MoveCatalogToFolder/' + droppedEl.data("ttId"), {
                        data: {
                            targetFolderId: $(this).data("ttId"),
                        },
                        onSuccess: function(response) {
                            if (targetParentId == response.parentId) {
                                messaging.showGlobalMessage("success", null, "Der Katalog wurde verschoben.");
                                if (!devis.catalogTreeTable.find('[data-tt-id="' + targetParentId + '"]').is(".expanded")) {
                                    devis.catalogTreeTable.treetable("expandNode", targetParentId);
                                }
                                devis.catalogTreeTable.treetable("move", response.id, response.parentId || -1);
                                var node = devis.catalogTreeTable.treetable("node", response.parentId || -1);
                                devis.catalogTreeTable.treetable("sortBranch", node, devis.treeSortFunction);
                            }
                        },
                        onError: function(data) {
                            messaging.showGlobalMessage("danger", null, "Fehler beim verschieben des Katalogs.");
                        }
                    });
                },
                hoverClass: "accept",
                over: function(e, ui) {
                    var droppedEl = ui.draggable;
                    var overEl = this;
                    setTimeout(() => {
                        if (overEl != droppedEl[0] && $(overEl).is('.ui-droppable-hover') && !$(overEl).is(".expanded")) {
                            devis.catalogTreeTable.treetable("expandNode", $(overEl).data("ttId"));
                        }
                    }, 1000);
                }
            });
        });
    },

    treeSortFunction: function(a, b) {
        var aIsFolder = a.row.is('.folder'),
            bIsFolder = b.row.is('.folder'),
            valA = (!aIsFolder ? 'B ' : 'A ') + $.trim(a.row.find("td:eq(0)").text()).toUpperCase(),
            valB = (!bIsFolder ? 'B ' : 'A ') + $.trim(b.row.find("td:eq(0)").text()).toUpperCase();
        if (valA > valB) return 1;
        if (valA < valB) return -1;
        return 0;
    },

    addNewPosition: function(rowEl, addBefore) {
        var newItemEl = rowEl.closest('table').find('[data-new]:not(:visible)').clone();
        newItemEl.removeClass('d-none');
        newItemEl.find('[data-devis-field]').text('');
        if (!addBefore) {
            var number = rowEl.find('.base-number').text().trim();
            newItemEl.find('[data-devis-field="Number"]').text(number);
            rowEl.after(newItemEl);
        } else {
            var number = rowEl.prev().find('.base-number').text().trim();
            newItemEl.find('[data-devis-field="Number"]').text(number);
            rowEl.before(newItemEl);
        }
        onContentReady(newItemEl);
        newItemEl.find('[data-devis-field="Number"]').attr('contenteditable', true).focus();
    },

    addPositionToDevis: function(positionId) {
        connection.getJson('/Devis/Default/AddPositionToDevis', {
            data: {
                id: positionId,
                devisDocumentId: devis.devisDocumentId,
            },
            onSuccess: function() {
                connection.loadPart($('#devis-positions'), null, () => {
                    var $container = $('#devis-positions .scroll-container');
                    var $scrollTo = $('[data-original-id="'+positionId+'"]');
                    $container.scrollTop(
                        $scrollTo.offset().top - $container.offset().top + $container.scrollTop() - 80
                    );
                });
            },
        });
    },

    removePositionFromDevis: function(positionId) {
        messaging.askYesNo('Position entfernen?', 'Willst du die Position aus dem Eigen-Devis entfernen?', function () {
            connection.getJson('/Devis/Default/RemovePositionFromDevis', {
                data: {
                    id: positionId,
                    devisDocumentId: devis.devisDocumentId,
                },
                onSuccess: function() {
                    $(`#devis-positions-card [data-id="${positionId}"]`).remove();
                    messaging.showGlobalMessage('success', null, 'Die Position wurde entfernt.');
                },
                onError: function() {
                    messaging.showPermanentGlobalMessage('danger', null, 'Die Position konnte nicht entfernt werden.');
                },
            });
        });
    },

    saveDevisPosition: function($rowEl, data) {
        if ($rowEl.attr('data-id')) {
            connection.getJson('/Devis/Default/SaveDevisPosition', {
                type: 'POST',
                data: {
                    id: $rowEl.attr('data-id'),
                    data: data,
                },
                onSuccess: function (response) {
                    $rowEl.find('[data-add-to-devis] i').toggleClassIf('d-none',
                        ($rowEl.find('[data-devis-field="Unit"]').attr('data-val') || '').trim() === ''
                    );
                    $rowEl.toggleClassIf('main-position', response.IsMainPosition);
                },
            });
        } else {
            var fields = $rowEl.find('[data-devis-field]');
            $.each(fields, (i, el) => {
                var $el = $(el);
                var fieldName = $el.attr('data-devis-field');
                if (fieldName === 'Unit') {
                    data[fieldName] = $el.attr('data-val');
                } else if (fieldName === 'Content') {
                    data[fieldName] = $el.data('editor') ? $el.data('editor').getData() : '';
                } else {
                    data[fieldName] = $el.html().trim();
                }
            });
            //
            $rowEl.find('[data-devis-field].is-invalid').removeClass('is-invalid');
            if (data.Number && data.Content) {
                data['DevisCatalogId'] = $rowEl.closest('[data-catalog-id]').attr('data-catalog-id');
                connection.getJson('/Devis/Default/CreateCatalogPositionSlideIn', {
                    type: 'POST',
                    data: data,
                    onSuccess: function (saveResponse) {
                        messaging.showGlobalMessage('success', null, 'Die Position wurde hinzugefügt.');
                        var catalogId = $('#catalog-tree-table .active').attr('data-tt-id');
                        var mainPositionId = $rowEl.closest('[data-mainposition-id]').attr('data-mainposition-id');
                        connection.loadPartWith($('#catalog-subpositions'), {
                            data: {
                                id: catalogId,
                                mainNumber: $('[name=CatalogsMainNumber]').val(),
                                mainPositionId: mainPositionId
                            },
                            onSuccess: function(response) {
                                var $container = $('.col-positions');
                                var $scrollTo = $container.find(`[data-id="${saveResponse.id}"]`);
                                var scrollTop = $scrollTo.offset().top - $container.offset().top + $container.scrollTop();
                                $container.animate({ scrollTop }, 0);
                            },
                        });
                    },
                    onError: function(response) {
                        connection.addFormErrors($rowEl, response);
                        $.each(response.errors || {}, function(index, item) {
                            var field = $rowEl.find('[data-devis-field="' + item.field + '"]');
                            field.addClass('is-invalid');
                        });
                    },
                });
            } else {
                if (!data.Number) {
                    $rowEl.find('[data-devis-field="Number"]').addClass('is-invalid');
                }
                if (!data.Content) {
                    $rowEl.find('[data-devis-field="Content"]').addClass('is-invalid');
                }
            }
        }
    },

    focusNextOf: function($inputEl) {
        var nextEditable = devis.findNextRightOf($inputEl);
        if (nextEditable) {
            $inputEl.trigger('blur');
            nextEditable.trigger('click').focus();
        }
    },

    findNextRightOf: function(inputEl) {
        var $tbody = inputEl.closest('tbody');
        var fields = $tbody.find('[data-devis-field]');
        var indexOf = fields.index(inputEl);
        return (indexOf + 1 < fields.length) ? $(fields[indexOf + 1]) : $(fields[0]);
    },

};

window.devis = devis;